import { BOTTOM_SECTIONS_TRIGGER_HEIGHT_RATIO } from '@/pages/journalArticle/lib/useJournalArticleConstants';

const useBottomSectionsScroll = (targetRef: Ref<HTMLElement | null>) => {
  const isReached: Ref<boolean> = ref(false);

  const scrollHandler = (): void => {
    if (!targetRef.value || isReached.value) return;

    const { y, height } = targetRef.value.getBoundingClientRect();
    const offset = y - height * BOTTOM_SECTIONS_TRIGGER_HEIGHT_RATIO;

    if (offset <= 0) {
      isReached.value = true;
      window.removeEventListener('scroll', scrollHandler);
    }
  };

  onMounted(() => {
    nextTick(() => {
      window.addEventListener('scroll', scrollHandler);
    });
  });

  onBeforeUnmount(() => {
    window.removeEventListener('scroll', scrollHandler);
  });

  return {
    isReached,
  };
};

export default useBottomSectionsScroll;
